import { render, staticRenderFns } from "./md.vue?vue&type=template&id=2b552169&"
import script from "./md.vue?vue&type=script&lang=js&"
export * from "./md.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports